import PageLayout from '../components/global/PageLayout';
import BookingSiteSettings from '../components/businesses/BookingSiteSettings';
import useUser from '../hooks/global/useUser';
import { isUserAdminOrManager } from '../utils/global/helper';
import { canIndependentManageShop } from '../helpers/businesses';
import { LoadedUser } from '../interfaces';

export default function BookingSitePage() {
  const { user } = useUser<LoadedUser>();

  const canManageShop =
    !!user && (isUserAdminOrManager(user) || canIndependentManageShop(user));

  return (
    <PageLayout
      headerIsHidden
      withoutChildContainer
      // The customizer owns its own padding — it runs edge to edge.
      containerProps={{ p: 0, gap: 0 }}
      guard={{ isAllowed: canManageShop }}>
      <BookingSiteSettings />
    </PageLayout>
  );
}
